<template>
  <div id="rootElement">
    <nav class="navbar">
      <div class="logoWrapper">
        <div class="logo" v-if="customerView||impressumHeader">
          <img src="../../assets/images/adalliance.png">
        </div>
        <router-link v-if="!customerView&&!impressumHeader" class="logo" :to="'/'">
          <img src="../../assets/images/adalliance.png">
        </router-link>
        <div v-if="customerView||impressumHeader" class="toolNameWrapper">
          <span class="toolName">AdSize Prediction &copy;</span>
        </div>
        <router-link v-if="!customerView&&!impressumHeader" :to="'/'" class="toolNameWrapper">
          <span class="toolName">AdSize Prediction &copy;</span>
        </router-link>
      </div>
      <unicon @click="toggleNav" class="navbar-toggle" name="bars" fill="#394956"
              style="cursor: pointer"></unicon>
      <div v-if="!customerView && !impressumHeader" class="navContainer" ref="mainNav">
        <div class="nextBestClick">
                  <span class="wrapper-span">Molten Config <span v-tooltip="tooltip" class="icon icon-info"></span><span
                      v-tooltip="tooltipConfig" @click="copyToClipboard" class="copy icon icon-duplicate"></span>
                  </span>
        </div>
        <ul class="main-nav" id="js-menu" ref="jsMenu">
          <li class="nav-li-item">
            <UserDropdown v-if="!customerView" :username="username" :usermail="usermail"></UserDropdown>
          </li>
        </ul>
      </div>

    </nav>
  </div>

</template>

<script>

import UserDropdown from "./UserDropdown";

export default {
  name: "Header",
  components: {UserDropdown},
  props: [
    'username',
    'usermail'
  ],
  computed: {
    impressumHeader: function () {
      return (this.route === 'impressum');
    },
    route: function () {
      return this.$route.name
    },
    customerView() {
      let key = this.$route.query.key;
      return typeof key !== 'undefined';
    },
    tooltip() {
        return 'Standardmäßig werden 10% aller Impressions für die Datensammlung der AdSize Prediction verwendet. Dieser Prozentsatz kann in der AdControl im AdSize Prediction Modul verändert werden. Zum Kopieren einer Vorlage für die Config bitte auf das Kopieren Icon klicken.';
    },
    tooltipConfig() {
        return "{\n\t\"percentage\":10\n}";
    }
  },
  methods: {
    toggleNav: function () {
      this.$refs.mainNav.classList.toggle("active");
    },
    copyToClipboard () {
      this.$clipboard(this.tooltipConfig);
      this.$noty.info('kopiert');
    }
  }
}


</script>

<style scoped lang="scss">
 .createPreset {
  .unicon.icon {
    width: 20px;
    margin-right: 4px;
  }
}

.navContainer {
  display: flex;
  flex-flow: wrap;
  height: 100%;

  ul {
    height: 100%;
    margin: 0;
  }
}

.nextBestClick {
  margin-right: 40px;
  display: flex;
  flex-flow: wrap;
  align-items: center;
  height: 100%;

  .topAction:not(:first-child) {
    margin-left: 20px;
  }

  &.active {
    display: flex;
  }
}

.nav-li-item > span {
  margin: auto;
  padding-top: 1em;
  padding-bottom: 1em;
  font-size: 16px;
}

.nav-li-item > a {
  margin: auto;
}

#rootElement {
  background-color: rgb(255,255,255);
}

.logoWrapper {
  display: flex;
  align-items: center;
}

.navbar {
  font-size: 17px;
  background-color: rgb(255,255,255);
  padding-bottom: 10px;
  transition: width 0.3s ease-in-out;
}

.main-nav, .navContainer {
  list-style-type: none;
  display: none;
  height: 100%;
  padding-left: 0;
}

.nav-links,
.logo, .toolName {
  text-decoration: none;
  color: inherit;
  height: 100%;
}

.toolName {
  font-size: 1em;
  font-weight: bold;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
}

.toolNameWrapper {
  width: auto;
  display: inline-block;
  padding-left: 2em;
  color: #394956;
  text-decoration: none;
}

.main-nav li {
  text-align: center;
}

.logo {
  display: inline-block;
  font-size: 22px;
  margin-top: 10px;
  margin-left: 20px;
}

.navbar-toggle {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  font-size: 24px;
}

.active {
  display: block;
}

.logo > img {
  height: 30px;
}

 .createButton {
  padding: 9px 19px;
}

@media screen and (min-width: 1225px) {
  #js-menu > li {
    margin-right: 30px;
  }

  .marginLeft {
    margin-left: 20px;
  }

  .nav-content {
    width: 80%;
    margin: auto;
  }
  .navbar {
    justify-content: space-between;
    padding-bottom: 0;
    height: 70px;
    margin: auto;
    display: flex;
    align-items: center;
    //width: 85%;
    //max-width: 1400px;
  }

  .logo > img {
    height: 45px;
  }

  .main-nav, .navContainer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .logo {
    margin-top: 0;
  }

  .navbar-toggle {
    display: none;
  }

  .nav-links {
    margin: 0;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: center;
  }

  .nav-links.tab.active, .nav-links.tab:hover {
    border-top: 3px solid #00b6ed;
    color: #00b6ed;
  }
}

@media screen and (max-width: 1225px) {
  .main-nav, .navContainer {
    &.active {
      .nextBestClick {
        display: flex;
        justify-content: center;
        margin: 10px 0;
      }

      .main-nav {
        display: flex;
        flex-flow: column;

        a {
          padding: 10px;
        }
      }

      .navContainer {
        display: flex;
      }
    }
  }
}

@media screen and (min-width: 1450px) {
  .navbar {
    width: 85%;
  }
}

@media screen and (max-width: 1450px) {
  .navbar {
    width: 93%;
  }
}

@media screen and (max-width: 1350px) {
  .navbar {
    width: 100%;
  }
}

.icon {
  padding: 0.3em;
}

.wrapper-span{
  cursor: default;
}
.copy{
  cursor: pointer;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}


</style>